module.exports = __webpack_public_path__ + "_assets/img/Frame1204.c4dbc2e1.svg";